import userManager from "./OIDCAuthHandler";
import AppSettings from "../../utils/appSettings";
import { persistor } from "../../store";
import { clearLocalStorage, clearDeeplink } from "../../store/persistStore";

let isRefreshing = false
let refreshSubscribers = []

const onTokenRefreshed = (token) => {
  refreshSubscribers.forEach((callback) => callback(token))
  refreshSubscribers = []
}

const addRefreshSubscriber = (callback) => {
  refreshSubscribers.push(callback)
}

export const refreshToken = async () => {
  if (isRefreshing) {
    return new Promise((resolve) => {
      addRefreshSubscriber((token) => resolve(token))
    })
  }

  isRefreshing = true

  try {
    const user = await userManager.signinSilent()
    if (user?.access_token) {
      localStorage.setItem('token', user.access_token)
      onTokenRefreshed(user.access_token)
      return user.access_token
    }
    return null
  } catch (error) {
    console.error('Silent token refresh failed:', error)
    return null
  } finally {
    isRefreshing = false
  }
}

export const handleTokenRefreshFailure = () => {
  localStorage.removeItem('token')
  clearLocalStorage()
  clearDeeplink()
  userManager.removeUser().catch(() => {})
  persistor.purge().catch(() => {})
  const logoutUrl = `${AppSettings.identityServer}/account/logout?clientid=${AppSettings.clientId}&returnurl=${window.location.origin}`
  window.location.replace(logoutUrl)
}

export const initTokenRefreshListeners = () => {
  userManager.events.addAccessTokenExpired(() => {
    console.log('Token expired, attempting silent renew...')
    const token = localStorage.getItem('token')
    if (!token) return
    refreshToken().then((newToken) => {
      if (!newToken) {
        handleTokenRefreshFailure()
      }
    })
  })

  userManager.events.addSilentRenewError((error) => {
    console.error('Silent renew error:', error)
    const token = localStorage.getItem('token')
    if (token) {
      handleTokenRefreshFailure()
    }
  })

  userManager.events.addUserLoaded((user) => {
    if (user?.access_token) {
      localStorage.setItem('token', user.access_token)
    }
  })
}
